import { useDispatch } from 'react-redux';
import { addNotification } from '../store';
import { useGetPresentationBuildMutation } from '../services';
import { downloadBlobFile, captureError } from '@clatter/platform';

interface UsePresentationDownloadOptions {
  presentationId: number | string;
  displayName?: string;
}

export const usePresentationDownload = ({ presentationId, displayName }: UsePresentationDownloadOptions) => {
  const dispatch = useDispatch();
  const [downloadBuild, { isLoading: isDownloading }] = useGetPresentationBuildMutation();

  const handleDownload = async () => {
    try {
      dispatch(
        addNotification({
          type: 'success',
          message: `Preparing download for "${displayName || 'presentation'}". If it doesn't start automatically, check your browser settings.`,
        }),
      );

      const blob = await downloadBuild({ presentationId: Number(presentationId) }).unwrap();
      if (blob) {
        const filename = `${displayName || 'presentation'}.pptx`;
        downloadBlobFile(blob, filename, 100);
      }
    } catch (error) {
      captureError(error, { message: 'Failed to download presentation', component: 'usePresentationDownload' });
      dispatch(
        addNotification({
          type: 'error',
          message: 'Couldn\'t download the presentation. Please try again.',
        }),
      );
    }
  };

  return {
    handleDownload,
    isDownloading,
  };
};
